module.exports = __webpack_public_path__ + "static/media/tazumi.58c91ea4.png";